import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

// components
import Login from '../../components/Auth/Login';
// stores
import UserStore from '../../stores/UserStore';
// tools
import LoadingUI from '../../tools/Loading';
// css
import './Auth.css';

const LoginPage = observer(
class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: "" };
  }
  render() {
    const { errorMessage } = this.state;
    return (
      <div className="AuthPage-container">
        <div className="AuthPage-control">
          <Login errorMessage={errorMessage} onLogin={this.loginOnSubmit} />
        </div>
        <div className="AuthPage-switch-link">
          <Link to="/auth/recovery">Forgot Password?</Link>/
          <Link to="/auth/signup">Sign me up!</Link>
        </div>
      </div>
    );
  }

  loginOnSubmit = (email, password) => {
    LoadingUI.show();
    this.setState({ errorMessage: "" });
    UserStore
    .login(email, password)
    .catch(e => {
      LoadingUI.hide();
      this.setState({ errorMessage: e.message });
    });
  }
});

export default LoginPage;


// WEBPACK FOOTER //
// ./src/pages/Auth/LoginPage.js